import {Mapper} from '@s-ui/domain'

export class LastDetailsViewedDataToLastDetailsViewedListValueObjectMapper extends Mapper {
  constructor({
    lastDetailsViewedListValueObjectFactory,
    lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper
  }) {
    super({
      lastDetailsViewedListValueObjectFactory,
      lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper
    })
    this._lastDetailsViewedListValueObjectFactory = lastDetailsViewedListValueObjectFactory
    this._lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper =
      lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper
  }

  /**
   * @param {String} data
   */
  map = (items = {items: []}) => {
    const lastDetailsViewedListItems = items
      .map(id => this._lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper.map(id).toJSON())
      .reverse() // Sorting the list with the most recent detail viewed put it in front

    return lastDetailsViewedListItems
  }
}
